import type { BetterstartPresetDefinition } from '@preset-engine/types.js'

export const portfolioPreset: BetterstartPresetDefinition = {
  id: 'portfolio',
  title: 'Portfolio',
  description: 'Portfolio content module',
  kind: 'content',
  version: '1.0.0',
  dependencies: [],
  conflicts: [],
  schemaFiles: ['portfolio.json'],
  files: [],
  packageDependencies: [],
  devDependencies: [],
  envSections: [],
  configure: 'none'
}
